import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./components/Home";
import CssBaseline from "@material-ui/core/CssBaseline";
import About from "./components/About";
import Contact from "./components/Contact";
import Shop from "./components/Shop";
import SingleProduct from "./components/SingleProduct";
import { getPostScroll } from "./actions/productActions";
import { connect } from "react-redux";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { getCategories } from "./actions/catActions";
import { getWesbite } from "./actions/WebsiteActions";
import { getCart } from "./actions/cartAction";
import PrivateRoute from "./utlis/PrivateRoute";
import jwt_decode from "jwt-decode";
import store from "./Store";
import Axios from "axios";
import Login from "./components/Login";
import setAuthToken from "./utlis/setAuthToken";
import { setCurrentUser, logoutUser } from "./actions/authActions";
import Register from "./components/Register";
import { getWishList } from "./actions/wishlistActions";
import Cart from "./components/Cart";
import Wishlist from "./components/Wishlist";
let theme0 = createMuiTheme({
    palette: {
        primary: {
            main: "#000",
        },
        secondary: {
            main: "#fff",
        },
        type: "dark",
    },
});

let themeA = createMuiTheme({
    palette: {
        primary: {
            main: "#3d2539",
        },
        secondary: {
            main: "#303030",
        },

        type: "light",
    },
});

function App(props) {
    const [geodata, setgeodata] = useState(Object);
    const [UsERaGENT, setUsERaGENT] = useState("");
    const [ipaddress, setipaddress] = useState("");
    const [Latitiude, setLatitiude] = useState("");
    const [Longitude, setLongitude] = useState("");
    const [countryname, setcountryname] = useState("");
    const [region, setregion] = useState("");
    const [city, setcity] = useState("");
    console.log(props.main, "appjs");
    console.log(navigator.userAgent.toString(), "usersa");
    // const getLocation = () => {
    //     console.log("geo");
    //     if (navigator.geolocation) {
    //         navigator.geolocation.watchPosition(showPosition);
    //         console.log("geo", "hai");
    //     } else {
    //         // x.innerHTML = "Geolocation is not supported by this browser.";
    //     }
    // };
    // const showPosition = (position) => {
    //     console.log(position.coords.latitude, position.coords.longitude, "geo");
    // };
    useEffect(() => {
        Axios.get("https://api.bigdatacloud.net/data/client-info")
            .then((res) => {
                console.log(res.data, "doneip");
                // setgeodata(res.data);
                setipaddress(res.data.ipString);
                setUsERaGENT(res.data.userAgentRaw);
                setLatitiude(res.data.os);
                setLongitude(res.data.isBehindProxy);
                setcountryname(res.data.isMobile);
                setregion(res.data.ipType);
                setcity(res.data.device);
            })
            .catch((err) => {
                console.log(err.response, "doneip");
            });
        // getLocation();
    }, []);
    // console.log(geodata, "trt");

    useEffect(() => {
        console.log("main1");

        if (city.length > 0) {
            console.log("main2");
            const newPost = {
                userAgent: UsERaGENT,
                ipaddress: ipaddress,
                lat: Latitiude,
                long: Longitude,
                countryname: countryname,
                region: region,
                city: city,
            };
            Axios.post("/api/posts/post/logs", newPost)
                .then((res) => {
                    console.log(res.data, "succdess");
                })
                .catch((err) => {
                    console.log(err.response, "errip");
                });
        }
    }, [city]);
    let muitheme;
    muitheme = theme0;
    if (props.main.theme == "light") {
        muitheme = themeA;
    } else if (props.main.theme == "dark") {
        muitheme = theme0;
    }

    useEffect(() => {
        props.getPostScroll(1);
        props.getCategories();
        props.getWesbite();
    }, []);

    useEffect(() => {
        if (props.auth.isAuthenticated) {
            props.getCart();
            props.getWishList();
        }
        if (localStorage.jwtToken) {
            //set auth token to header auth
            setAuthToken(localStorage.jwtToken);
            //decode token and get userinfo
            const decoded = jwt_decode(localStorage.jwtToken);
            //set User and isAuthenticated
            store.dispatch(setCurrentUser(decoded));

            //check for expired token
            const currentTime = Date.now() / 1000;
            if (decoded.exp < currentTime) {
                //logoutuser
                store.dispatch(logoutUser());

                // store.dispatch(clearCurrentProfile());
                //Redirect to Login
                window.location.href = "/login";
            }
        }
    }, [props.auth.isAuthenticated]);

    return (
        <Router>
            <ThemeProvider theme={muitheme}>
                <CssBaseline />

                <Switch>
                    <Route path="/">
                        <Switch>
                            {/* <Route exact path="/login" component={Login} /> */}
                            <Route exact path="/" component={Home} />
                            <Route exact path="/about" component={About} />
                            <Route exact path="/contact" component={Contact} />
                            <Route exact path="/shop" component={Shop} />
                            <Route exact path="/cart" component={Cart} />
                            <Route
                                exact
                                path="/wishlist"
                                component={Wishlist}
                            />

                            <Route
                                exact
                                path="/Product/:id"
                                component={SingleProduct}
                            />
                            <Route exact path="/login" component={Login} />
                            <Route
                                exact
                                path="/register"
                                component={Register}
                            />
                        </Switch>
                    </Route>
                </Switch>
            </ThemeProvider>
        </Router>
    );
}

const mapStateToProps = (state) => ({
    main: state.main,
    theme: state.main.theme,
    auth: state.auth,
});
export default connect(mapStateToProps, {
    getPostScroll,
    getCategories,
    getWesbite,
    getCart,
    getWishList,
})(App);
